import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NovedadescomercialesComponent } from './components/novedadescomerciales/novedadescomerciales.component';

const routes: Routes = [
 { path: 'novedadescomerciales', component: NovedadescomercialesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NovedadescomercialesRoutingModule { }
